/* 
Common code for each of the views making up the scheduled job page.
*/
import * as action from "@/store/scheduled-jobs/action-types";
import lookupMixins from "@/mixins/lookup.mixins";

export default {
  mixins: [lookupMixins],
  data() {
    return {
      arrivedFromListing: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.arrivedFromListing = from.path.startsWith("/scheduled-jobs");
    });
  },
  computed: {
    scheduledJobId() {
      return parseInt(this.$route.params.id);
    },
    nextPageAction() {
      return action.LIST_NEXT_PAGE;
    },
    previousPageAction() {
      return action.LIST_PREVIOUS_PAGE;
    },
    breadcrumbs() {
      return this.$store.state.scheduledJobs.view.breadcrumbs;
    },
    scheduledJob() {
      return this.$store.state.scheduledJobs.view.data;
    },
    title() {
      const type = this.scheduledJob.type;
      return type ? this.lookups.jobTypeDescriptions[type] : "...";
    }
  },
  watch: {
    scheduledJobId() {
      this.refresh();
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.$store.dispatch(action.VIEW_REFRESH, this.scheduledJobId);
    }
  }
};
